module.exports = __webpack_public_path__ + "static/media/about-partner-carousel-7.c7fcb038.png";